/* LiveYourBest – små beteendetillägg ovanpå Dawn */
(function () {
  // Externa länkar i huvudmeny, mobilmeny och footer (t.ex. Kläder/Protein → liveyourbest.store)
  // öppnas i ny flik. Butikens egna domäner, kundkonto (shopify.com) och Shop-appen undantas.
  var skip = [location.hostname, 'shopify.com', 'myshopify.com', 'shop.app'];
  function isExternal(href) {
    try {
      var u = new URL(href, location.href);
      if (u.protocol !== 'http:' && u.protocol !== 'https:') return false;
      return !skip.some(function (h) { return u.hostname === h || u.hostname.endsWith('.' + h); });
    } catch (e) { return false; }
  }
  function apply(root) {
    (root || document).querySelectorAll('.header__inline-menu a[href], .menu-drawer a[href], .footer a[href]').forEach(function (a) {
      if (isExternal(a.getAttribute('href'))) {
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener');
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { apply(); });
  else apply();
  // Temaredigeraren laddar om sektioner dynamiskt
  document.addEventListener('shopify:section:load', function (e) { apply(e.target); });
})();
